import axios from "axios";
import { lang } from "moment";
import Swal from "sweetalert2";

export const getCountries = async (lang) => {
  try {
   
    const brear = localStorage.getItem("token");
    const { data } = await axios.get("/v1/admin/countries", {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        "Accept-Language": lang,
        
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const getCountriesUser = async (lang) => {
  try {
   
    const brear = localStorage.getItem("token");
    const { data } = await axios.get("/v1/countries", {
      headers: {

        "Accept-Language": lang,
        
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const showCountry = async (id, selectedLangCode) => {
  try {
    const brear = localStorage.getItem("token");
    let lang = localStorage.getItem("i18nextLng");
    if (selectedLangCode) {
      lang = selectedLangCode;
    }
    const { data } = await axios.get(`/v1/admin/countries/${id}`, {
      params: {
        lang: lang,
      },
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        "Accept-Language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postCountry = async (postData,lang) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.post("/v1/admin/countries", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        
        "Accept-Language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const UpdateCountry = async (postData,lang,id) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.post(`/v1/admin/countries/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        
        "Accept-Language": lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const deleteCountries = async (id,lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.delete(`v1/admin/countries/${id}`, {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};
